import { ExperimentalDiffOperationChange, Reflect } from "@workcanvas/reflect/client";
import { M, mutators as replicacheMutators } from "shared/datamodel/mutators";
import { runOnClient } from "./window-utils";

export function createReplicacheInstance(
  accountId: string,
  userId: string,
  documentId: any,
  repsToken: string,
  debugWorker: boolean = false,
  onOnlineChange?: (online: boolean) => void
): Reflect<M> {
  const workerOrigin = debugWorker ? process.env.PUBLIC_WORKER_HOST_DEBUG! : process.env.PUBLIC_WORKER_HOST!;

  let region: string | null = null;
  runOnClient(() => {
    region = sessionStorage.getItem("region");
  });

  console.info(`Connecting to worker at ${workerOrigin} region: ${region}`);
  const r = new Reflect<M>({
    socketOrigin: workerOrigin,
    userID: userId,
    roomID: documentId,
    auth: JSON.stringify({
      authToken: repsToken,
      accountId: accountId,
      userId: userId,
      region,
    }),
    mutators: replicacheMutators,
    logLevel: "error",
    onOnlineChange: onOnlineChange,
    hiddenTabDisconnectDelay: 1000 * 60 * 10, // 10 minutes
    enableAnalytics: true,
  });

  return r;
}

export async function fillBoardContent(
  accountId: string,
  userId: string,
  destinationDocumentId: string,
  repsToken: string,
  content: Record<string, any>
) {
  const destinationReps = createReplicacheInstance(accountId, userId, destinationDocumentId, repsToken, false);
  const elements = Object.entries(content).map(([key, value]) => {
    return {
      id: key,
      value,
    };
  });
  destinationReps.mutate.putManyWithSignal(elements);
  await new Promise<void>((resolve) => {
    destinationReps.experimentalWatch((diff) => {
      const controlKey = diff.find(
        (el) => el.op === "change" && el.key === "control/completed-signal"
      ) as ExperimentalDiffOperationChange<string>;
      if (controlKey && controlKey.newValue === "completed") {
        resolve();
        destinationReps.close();
      }
    });
  });
}
